import { render, staticRenderFns } from "./AppSelector.vue?vue&type=template&id=1300c2f0&scoped=true&"
import script from "./AppSelector.vue?vue&type=script&lang=ts&"
export * from "./AppSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300c2f0",
  null
  
)

export default component.exports